import * as mutations from './mutations';
import products from './modules/products';
import common from '../../common/store/store';

export default {
  modules: {
    common,
    products
  },
  state: {
    // Configs
    orderFormConfig: null,

    // ChoiceList model
    choiceList: [],
    previousChoiceList: null,

    // Payments
    recurrence: '' // "x1" | "x3"
  },
  getters: {
    // Configs
    orderFormConfig: state => state.orderFormConfig,

    // ChoiceList model
    choiceList: state => state.choiceList,
    previousChoiceList: state => state.previousChoiceList,

    // Payments
    recurrence: state => state.recurrence,

    // ChoiceList choices
    getSelectedChoices: (state, getters, rootstate) => {
      return getters.choices.filter(choice =>
        choice.recurrence === state.recurrence &&
        choice.paymentMethod === rootstate.common.paymentMethod &&
        state.choiceList.includes(choice.stackLetter)
      );
    },
    /**
     * Mandatory getter in order to get the totalAmount to pass to the payment iFrame
     * @param {Object} state
     * @param {Object} getters
     * @returns
     */
    getTotalAmount: (state, getters, rootstate) => {
      let totalAmount = 0;
      console.log('state.choiceList', state.choiceList);
      console.log('rootstate.common.paymentMethod', rootstate.common.paymentMethod);
      console.log('state.recurrence', state.recurrence);

      state.choiceList.forEach(stackLetter => {
        const choice = getters.choices.find(choice => {
          if (choice.paymentMethod === rootstate.common.paymentMethod &&
            choice.recurrence === state.recurrence &&
            choice.stackLetter === stackLetter) {
            return true;
          }

          return false;
        });

        if (typeof choice !== 'undefined') {
          totalAmount += parseFloat(choice.price);
        }
      });

      return totalAmount;
    }
  },
  mutations: {
    // Model
    [mutations.SET_ORDER_FORM_CONFIG](state, data) {
      state.orderFormConfig = data;
    },

    // ChoiceList model
    [mutations.SET_CHOICE_LIST](state, data) {
      state.choiceList = data;
    },
    [mutations.SET_PREVIOUS_CHOICE_LIST](state, data) {
      state.previousChoiceList = data;
    },

    // Payments
    [mutations.SET_RECURRENCE](state, data) {
      state.recurrence = data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/multiple/store/store.js